import axios from 'axios';
import { IAfterCallPayload, ICallToken } from 'entities/Calls/Twilio.models';

const basePath = '/conversations';

export const twilioService = {
  getVoiceCallToken: (): Promise<ICallToken> => axios.post(`${basePath}/call`),
  trackVoiceCallDuration: (payload: IAfterCallPayload): Promise<void> => axios.post(`${basePath}/after-call`, payload),
};
